import { MDXProvider } from '@mdx-js/react'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/shared/ui/accordion'
import { Video } from './video'

const components = {
  Video,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
}

type ChangelogMDXProviderProps = {
  children: React.ReactNode
}

export function ChangelogMDXProvider({ children }: ChangelogMDXProviderProps) {
  return <MDXProvider components={components}>{children}</MDXProvider>
}
